/**
 * @copyright: 2020 NTWIST.
 * @Author: NTWIST
 * @Date: 2021-06-09 14:58:34
 * @Last Modified by: Pradeep Chandra
 * @Last Modified time: 2022-06-21 19:45:12
 */

import axios from "axios";
import { toaster, Message } from "rsuite";
import React from "react";
import BaseURL from "../api-common";

export async function getLatestInfluencerGraphData(
    endUserSession,
    clientPathName
) {
    try {
        let url =
            BaseURL.getBaseURL() +
            clientPathName +
            "/influencerAnalysis/getLatestInfluencerGraphData";

        let res = await axios({
            method: "get",
            url: url,
            withCredentials: true,
            data: {}
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return {
            dataExists: res.data.dataExists,
            graphData: res.data.graphData,
            influencersLatestTime: res.data.influencersLatestTime
        };
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={1500}>
                {
                    <text>
                        Could not get influencers.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}

export async function getInfluencersInDateRange(
    endUserSession,
    clientPathName,
    data
) {
    try {
        let url =
            BaseURL.getBaseURL() +
            clientPathName +
            "/influencerAnalysis/getInfluencersInDateRange";

        let res = await axios({
            method: "post",
            url: url,
            withCredentials: true,
            data: data
        });

        if (res.data.msg === "UNAUTHORIZED") {
            endUserSession();
            return;
        } else if (res.data.statusId === "ERROR") {
            throw "The server has encountered an error.";
        } else if (!res.data.isValidData) {
            throw "The request is invalid.";
        }

        return {
            dataExists: res.data.dataExists,
            graphData: res.data.graphData,
            influencersLatestTime: res.data.influencersLatestTime
        };
    } catch (e) {
        toaster.push(
            <Message type="error" showIcon closable duration={1500}>
                {
                    <text>
                        Could not get influencers.
                        <br />
                        Error: {e.toString()}
                    </text>
                }
            </Message>
        );
        return null;
    }
}
